import React, { useEffect, useState } from "react";
import { Search, Mail, Phone, Eye, User } from "lucide-react";

const ContactEnquiries = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  
  // State for Vision Popup (Read More)
  const [selectedVision, setSelectedVision] = useState<string | null>(null);

  useEffect(() => {
    fetch("https://luxuriyahomes.com/api/contact/all")
      .then((res) => res.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      })
      .catch((err) => console.error(err));
  }, []);

  const filteredData = data.filter((item: any) =>
    (item.firstName + " " + item.lastName).toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen text-white font-[Serif]">
      
      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div>
          <h2 className="text-3xl font-light">General Enquiries</h2>
          <p className="text-zinc-500 text-sm mt-1">Messages from website contact form</p>
        </div>
        <div className="relative">
          <Search className="absolute left-3 top-3 text-zinc-500" size={18} />
          <input 
            type="text" 
            placeholder="Search enquiries..." 
            className="bg-[#1c1c1c] border border-zinc-800 text-white pl-10 pr-4 py-2.5 rounded-full w-full md:w-80 focus:outline-none focus:border-amber-500 text-sm"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* TABLE */}
      {loading ? (
        <div className="text-center py-20 text-zinc-500 animate-pulse">Loading Enquiries...</div>
      ) : (
        <div className="bg-[#1c1c1c] border border-zinc-800 rounded-2xl overflow-hidden shadow-2xl">
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-zinc-900 text-zinc-500 text-xs uppercase tracking-wider font-bold">
                <tr>
                  <th className="p-5">Name</th>
                  <th className="p-5">Email & Phone</th>
                  <th className="p-5">Message (Vision)</th>
                  <th className="p-5 text-right">Received</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-800">
                {filteredData.map((item: any) => (
                  <tr key={item.id} className="hover:bg-zinc-800/30 transition-colors">
                    <td className="p-5">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center text-amber-500 font-bold">
                          {item.firstName.charAt(0)}
                        </div>
                        <span className="font-bold">{item.firstName} {item.lastName}</span>
                      </div>
                    </td>
                    <td className="p-5">
                      <div className="flex flex-col gap-1 text-sm">
                        <span className="text-zinc-300">{item.email}</span>
                        <span className="text-zinc-500 text-xs">{item.phoneNumber}</span>
                      </div>
                    </td>
                    <td className="p-5">
                      <p className="text-zinc-400 text-sm line-clamp-1 max-w-xs italic">"{item.vision}"</p>
                      <button 
                        onClick={() => setSelectedVision(item.vision)}
                        className="text-[10px] text-amber-500 uppercase tracking-widest font-bold mt-1 hover:underline"
                      >
                        Read Full
                      </button>
                    </td>
                    <td className="p-5 text-right text-zinc-500 text-sm">
                      {new Date(item.createdAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="md:hidden divide-y divide-zinc-800">
             {filteredData.map((item: any) => (
               <div key={item.id} className="p-5">
                 <div className="flex items-center justify-between mb-3">
                    <h3 className="font-bold text-white flex items-center gap-2">
                      <User size={16} className="text-amber-500"/> {item.firstName} {item.lastName}
                    </h3>
                    <span className="text-xs text-zinc-500">{new Date(item.createdAt).toLocaleDateString()}</span>
                 </div>
                 <div className="space-y-1 text-sm mb-3">
                    <p className="text-zinc-300">{item.email}</p>
                    <p className="text-zinc-500">{item.phoneNumber}</p>
                 </div>
                 <div className="bg-zinc-900 p-3 rounded border border-zinc-800">
                    <p className="text-zinc-400 text-xs italic line-clamp-2">"{item.vision}"</p>
                    <button onClick={() => setSelectedVision(item.vision)} className="text-amber-500 text-xs mt-2 font-bold">Read More</button>
                 </div>
               </div>
             ))}
          </div>
        </div>
      )}

      {/* VISION MODAL (Popup) */}
      {selectedVision && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-[#1c1c1c] border border-zinc-700 p-8 rounded-2xl max-w-lg w-full relative shadow-2xl">
            <button 
              onClick={() => setSelectedVision(null)}
              className="absolute top-4 right-4 text-zinc-500 hover:text-white"
            >
              ✕
            </button>
            <h3 className="text-xl text-white font-light mb-4">Client's Vision</h3>
            <div className="max-h-[60vh] overflow-y-auto pr-2">
                <p className="text-zinc-300 leading-relaxed text-sm whitespace-pre-wrap">{selectedVision}</p>
            </div>
            <div className="mt-6 pt-6 border-t border-zinc-800 text-right">
                <button 
                  onClick={() => setSelectedVision(null)}
                  className="text-amber-500 text-sm font-bold uppercase tracking-widest hover:text-amber-400"
                >
                  Close
                </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactEnquiries;